import { fetch } from "whatwg-fetch";

let cache = null;
let cacheBlog = null;

/**
 *
 * @param {boolean} limit // to fetch without content
 */
const readBlogs = (limit = false) => {
  if (cache) {
    return cache;
  }
  throw getAllBlogs(limit);
};

const readBlog = (id) => {
  // console.log(cacheBlog)
  if (cacheBlog) {
    return cacheBlog;
  }
  cacheBlog = null;
  throw getBlog(id);
};

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAllBlogs = (limit = false) => {
  console.log(limit);
  let url =
  BASE_URL + "/api/blogs?status=active&sort=priorityOrder";
  if (limit) {
    url += "&limit=true";
  }
  console.log(url);
  return fetch(url)
    .then((response) => response.json())
    .then((json) => {
      console.log('json value is', json)
      cache = json;
    });
};

const getBlog = (id) => {
  return fetch(`${BASE_URL}/api/blogs/${id}`)
    .then((response) => response.json())
    .then((json) => {
      // console.log(json)
      cacheBlog = json;
    });
};

export default {
  readBlogs,
  getAllBlogs,
  readBlog,
  getBlog,
};
